import React, { useEffect, useRef, useState } from 'react';
import heroImg from '../image/hero.jpg';
import chatbotImage from '../image/chatbot-phone.png';
import benefitImage from '../image/benefit-bot.png';
import stackedImage from '../image/why-use-chatbot.png';
import './HeroBanner.css';
import { Link } from 'react-router-dom';

import logo1 from '../image/company1.png';
import logo2 from '../image/company2.png';
import logo3 from '../image/company3.png';
import logo4 from '../image/company4.png';
import logo5 from '../image/company5.png';
import logo6 from '../image/company6.png';
import logo7 from '../image/company7.png';
import logo8 from '../image/company8.png';
import logo9 from '../image/company9.png';
import logo10 from '../image/company10.png';
import logo12 from '../image/company12.png';
import logo11 from '../image/Teamlease.png';
// import logo from '../image/logo.png'; // Replace with your actual logo
import { FaComments } from "react-icons/fa";


import {
  FaRobot,
  FaNetworkWired,
  FaLaptopCode,
  FaShieldAlt,
  FaDigitalTachograph,
  FaProjectDiagram,
  FaSmile,
  FaBriefcase,
  FaUsers
} from 'react-icons/fa';

// ------------------ Data ------------------

const services = [
  { icon: <FaNetworkWired size={32} />, title: 'IT Consulting', color: '#e7ffe4' },
  { icon: <FaLaptopCode size={32} />, title: 'Software Dev', color: '#e7ffe4' },
  { icon: <FaShieldAlt size={32} />, title: 'Cyber Security', color: '#e7ffe4' },
  { icon: <FaDigitalTachograph size={32} />, title: 'Digital Transform', color: '#e7ffe4' },
];

const stats = [
  { icon: <FaProjectDiagram />, number: 26, label: 'Projects Delivered' },
  { icon: <FaSmile />, number: 8, label: 'Happy Clients' },
  { icon: <FaBriefcase />, number: 12, label: 'Years of Excellence' },
  { icon: <FaUsers />, number: 98, label: 'Success Rate', isPercent: true },
];
const baseLogos = [
  logo11,
  logo1, logo2, logo3, logo4, logo5,
  logo6, logo7, logo8, logo9, logo10,
  logo12
];

const logos = [...baseLogos, ...baseLogos];
// ------------------ Counter Component ------------------

const Counter = ({ end, isPercent, trigger }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!trigger) return;

    let start = 0;
    const duration = 1500;
    const incrementTime = 20;
    const steps = duration / incrementTime;
    const increment = end / steps;

    const counter = setInterval(() => {
      start += increment;
      if (start >= end) {
        setCount(end);
        clearInterval(counter);
      } else {
        setCount(Math.ceil(start));
      }
    }, incrementTime);

    return () => clearInterval(counter);
  }, [end, trigger]);

  return <h3 className="stat-number">{count}{isPercent ? '%' : '+'}</h3>;
};

// ------------------ Stats Counter Section ------------------

const StatsCounter = () => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.5 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="stats-section" ref={ref}>
      <div className="container">
        <h2 className="stats-title">We Deliver Quality with Every Project</h2>
      </div>
      <div className="container stats-container">
        {stats.map((stat, index) => (
          <div className="stat-box" key={index}>
            <div className="icon-box">{stat.icon}</div>
            <Counter end={stat.number} isPercent={stat.isPercent} trigger={isVisible} />
            <p className="stat-label">{stat.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
};


const AnimatedChatbotRow = ({ children }) => {
  const ref = useRef();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={ref} className={`chatbot-row ${visible ? 'visible' : ''}`}>
      {children}
    </div>
  );
};
// ------------------ HeroBanner Main Component ------------------

const HeroBanner = () => {
  return (
    <>
      {/* Hero Section */}
      <section className="hero-banner d-flex flex-column flex-lg-row align-items-center justify-content-between px-4 px-md-5">
        <div className="hero-text animate__animated animate__fadeInLeft">
          <h1 className="hero-title">Talent Trek Technologies</h1>
          <p className="hero-subtitle text-muted">
            IT Services & Development | Software Solutions | Digital Transformation
          </p>
          <p className="hero-description">
            <strong>Talent Trek Technologies</strong> is a provider of <strong>Training & Development</strong> and software development services. We specialize in delivering full-fledged IT solutions for the <strong>healthcare</strong>, <strong>retail</strong>, and <strong>financial services</strong> sectors.
          </p>
          <div className="mt-4 d-flex gap-3 flex-wrap">
            <Link to="/contact" className="text-decoration-none">
            <button className="btn btn-primary hero-btn0">Contact Us</button>
            </Link>
            <Link to="/about" className="text-decoration-none">
            <button className="btn btn-outline-primary hero-btn0">View More</button>
            </Link>
          </div>
        </div>
        <div className="hero-image animate__animated animate__zoomIn">
          <img src={heroImg} alt="Hero" className="img-fluid hero-img" />
        </div>
      </section>
<section className="hero-banner-wrapper position-relative">
  <img src={require('../image/side1.png')} alt="Decor Left" className="decor-left" />
  <img src={require('../image/side2.png')} alt="Decor Right" className="decor-right" />

  <section className="hero-banner d-flex flex-column flex-lg-row align-items-center justify-content-between px-4 px-md-5">
    {/* Your Hero Text and Image */}
  </section>
</section>

     <div className="service-tags">
  <div className="service-card0 service-it">
    <div className="service-icon">🧩</div>
    <div className="service-title">IT Consulting</div>
    <p className="service-description"> We offer expert IT consulting to help businesses grow through technology, providing strategic guidance, tailored solutions, and full support to align IT with goals. </p>
  </div>
  <div className="service-card0 service-software">
    <div className="service-icon">💻</div>
    <div className="service-title">Software Dev</div>
    <p className="service-description"> We deliver scalable, secure software solutions tailored to business needs, focusing on innovation, efficiency, and high-quality development for long-term success. </p>
  </div>
  <div className="service-card0 service-cyber">
    <div className="service-icon">🛡️</div>
    <div className="service-title">Cyber Security</div>
    <p className="service-description"> We offer advanced cyber security solutions to protect your digital assets, ensuring data privacy, threat prevention, and business continuity with confidence. </p>
  </div>
  <div className="service-card0 service-digital">
    <div className="service-icon">🔁</div>
    <div className="service-title">Digital Transform</div>
    <p className="service-description"> We drive digital transformation by integrating modern technologies by enhancing efficiency, customer experience, and enabling sustainable growth. </p>
  </div>
</div>


 <section className="chatbot-wrapper">

      {/* Centered Title */}
      <div className="chatbot-container text-center my-5">
        <h2 className="chatbot-heading">Our Product</h2>
        <p className="chatbot-subtext">
          Our chatbot is a smart digital assistant that delivers instant answers, seamless support, and engaging conversations tailored to your needs. Powered by advanced AI and natural language processing, it understands context, boosts productivity, and effortlessly handles tasks with precision.
        </p>
      </div>

      {/* 1st Row – Image Right */}
      <div className="chatbot-row">
        <div className="chatbot-left">
          <div className="chatbot-icon-title">
            <div className="chatbot-icon"><FaComments /></div>
            <h2>Chat Bot</h2>
          </div>
          <p>
            Our intelligent chatbot is a smart digital assistant designed to enhance the way users interact with AI. It delivers instant answers, seamless support, and engaging conversations all tailored to your needs. Powered by advanced machine learning and natural language processing, it understands context and handles tasks with ease, boosting productivity and user satisfaction. It learns continuously from interactions, becoming smarter and more personalized over time. Whether for customer service, education, or everyday tasks, our chatbot transforms the user experience with intelligence and efficiency.
          </p>
        </div>
        <div className="chatbot-right">
          <img src={chatbotImage} alt="Chatbot Interface" className="chatbot-image" />
        </div>
      </div>

      {/* 2nd Row – Image Left */}
      <div className="chatbot-row">
  <div className="chatbot-left">
    <img src={stackedImage} alt="Why Use Chatbots" className="chatbot-image1" />
  </div>
  <div className="chatbot-right">
    <div className="chatbot-icon-title">
      <div className="chatbot-icon"><FaComments /></div>
      <h2>Why We Use Chatbots</h2>
    </div>
    <p>
      Chatbots are revolutionizing digital communication by offering 24/7 support,
      reducing response times, and efficiently managing repetitive tasks. They improve
      customer satisfaction while freeing up human agents to focus on complex issues.
      With real-time learning and natural language understanding, chatbots provide quick,
      relevant responses that keep users engaged.
    </p>
  </div>
</div>

      {/* 3rd Row – Image Right */}
      <div className="chatbot-row">
        <div className="chatbot-left">
          <div className="chatbot-icon-title">
            <div className="chatbot-icon"><FaRobot /></div>
            <h2>Benefits of Chatbots</h2>
          </div>
          <p className="text-muted">
            With round-the-clock availability, chatbots offer instant and accurate support, adapt to user behavior, and help reduce operational costs. They provide valuable analytics to inform business strategy and integrate effortlessly with websites, apps, and other platforms  making them a powerful tool for modern businesses.
          </p>
        </div>
        <div className="chatbot-right">
          <div className="chatbot-circle-img">
            <img src={benefitImage} alt="Chatbot Benefits" className="chatbot-image" />
          </div>
        </div>
      </div>

    </section>
      

      {/* Scroll-Animated Stats Section */}
      <StatsCounter />
      {/* / Companysection / */}
    <section className="company-section">
    <div className="container">
      <h2 className="section-title">Together with the Trusted</h2>
      <div className="logo-slider">
        <div className="logo-track">
          {logos.map((logo, index) => (
            <div key={index} className="logo-item">
              <img src={logo} alt={`Company ${index + 1}`} className="logo-img" />
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
{/* /Subscribe/ */}
    <section className="newsletter-section">
      <div className="container">
        <div className="newsletter-header">
          {/* <img src={logo} alt="Newsletter Logo" className="newsletter-logo" /> */}
        </div>
        <h2 className="newsletter-title">Talent Trek Technologies</h2>
        <div className="newsletter-form">
          <input type="email" placeholder="Enter your email" />
          <button type="submit">LOGIN</button>
        </div>
      </div>
    </section>  
    </>
  );
};

export default HeroBanner;